<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">


  <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
    <p-accordionTab header="{{ 'ZONES.LBL_ZONES' | translate }}" [selected]="tabSeleccionado === 'INFO'">
      <form [formGroup]="formulario" (ngSubmit)="!codeExists && onSubmit()" novalidate class="form-horizontal">
        <div class="grid form-group">
          <div class="col-12 md:col-6 lg:col-4">
            <div class="div-form">
              <label>* {{ 'ZONES.LBL_CODIGO' | translate }}</label>
              <div *ngIf="!idZona">
                <input type="text" pInputText id="codigo" name="nomCodigo" autocomplete="off" maxlength="10"
                  formControlName="codigoZona" (blur)="validateCode()" codigos>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigoZona.invalid">
                  {{'ZONES.LBL_CODIGO' | translate}} {{'LBL_REQUERIDO' | translate}}
                </div>
                <div class="p-message p-messages-error p-corner-all" *ngIf="codeExists">
                  {{'ZONES.LBL_CODIGOREPETIDO' | translate}}
                </div>
              </div>
              <div *ngIf="idZona">
                <label class="falso-combo-texto">{{zone.codigo}}</label>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-4">
            <div class="div-form">
              <label>* {{ 'ZONES.LBL_ZONA' | translate }}</label>
              <input type="text" pInputText name="zona" id="nombre" maxlength="50" capitalize
                formControlName="nombreZona" placeholder="{{ 'ZONES.LBL_ZONA' |
                          translate}}" />
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombreZona.invalid">
                {{'ZONES.LBL_ZONA' | translate}} {{'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-6 md:col-6 lg:col-4">
            <div class="div-form">
              <label>* {{ 'ZONES.LBL_CLASIFICACION' | translate }}</label>
              <div *ngIf="!existsBarrios">
                <p-dropdown disableTab  id="clasificacion" name="idClasificacionZona" [options]="clasificationZone"
                  placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                  formControlName="idClasificacionZona"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"></p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.idClasificacionZona.invalid">
                  {{'ZONES.LBL_CLASIFICACION' | translate}} {{'LBL_REQUERIDO' | translate}}
                </div>
              </div>
              <div *ngIf="existsBarrios">
                <label class="falso-combo-texto">{{zone.clasificacionZona}}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="grid form-group">
          <div class="col-12 md:col-12 lg:col-12">
            <div class="div-form">
              <label>* {{ 'ZONES.LBL_DESCRIPCION' | translate }}</label>
              <textarea style="width:100%; resize: none;" name="descripcion" id="descripcion" maxlength="500" rows="4"
                capitalize placeholder="{{ 'ZONES.LBL_DESCRIPCION' | translate}}"
                formControlName="descripcionZona"></textarea>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcionZona.invalid">
                {{'ZONES.LBL_DESCRIPCION' | translate}} {{'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
        </div>

        <div class="grid form-group" *ngIf="lisModalidades.length > 0">
          <!-- MODALIDADES -->
          <div class="col-12 md:col-6 lg:col-4">
            <div class="div-form">
              <label>* {{ "ZONES.LBL_MODALIDAD" | translate }}</label>
              <p-multiSelect id="modalidad" name="nomModalidad" [options]="lisModalidades"
                placeholder="{{ 'LBL_SELECCIONE' | translate }}" selectedItemsLabel="{0} {{
                  'LBL_ELEMENTOSSELECCIONADOS' | translate
                }}" formControlName="idsModalidad" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             optionValue="value"
                             optionLabel="label"></p-multiSelect>
              <div class="p-message p-messages-error p-corner-all" *ngIf="requeridoAdd">
                {{
                  "ZONES.LBL_MODALIDAD"
                    | translate
                }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
          </div>
          <!-- BOTON  AGRECAR -->
          <div class="col-12 md:col-6 lg:col-6 pt-5">
            <div class="div-form">
              <button type="button" icon="fa fa-plus" label="{{ 'BTN_AGREGAR' | translate }}" (click)="agregarModalidad()" [disabled]="validandoModalidad" pButton></button>
            </div>
          </div>
        </div>

        <!-- DATATABLE DE MODALIDADES -->
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="columnas" #dt [value]="lisModalidadAgregar" selectionMode="single"
              dataKey="idModalidad" [paginator]="true" [rows]="10"
              paginatorPosition="bottom" [loading]="validandoModalidad">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                    class="text-center">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{ row.modalidad }}</td>
                  <td class="text-center">
                    <div class="btn-group" role="group">
                      <button type="button" class="p-button p-button-success btn" icon="fa fa-trash"
                        data-toggle="tooltip" title="{{ 'BTN_INHABILITAR' | translate }}" pButton
                        (click)="eliminar(row)"></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ "MSG_NOHAYREGISTROS" | translate }}
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <div class="div-form">
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && lisModalidadAgregar == 0"
                style="justify-content:center">
                {{ "ZONES.LBL_MODALIDAD" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="grid form-group">
          <div class="col-6 md:col-3 lg:col-3">
            <p-checkbox formControlName="indicadorHabilitado" label="{{ 'ZONES.LBL_HABILITADO' | translate}}"
              binary="true" id="indicadorHabilitado" name="indicadorHabilitado">
            </p-checkbox>
          </div>
          <div class="col-6 md:col-3 lg:col-3">
            <p-checkbox formControlName="indicadorZonaLibre" label="{{ 'ZONES.LBL_ZONALIBRE' | translate}}"
              binary="true" id="indicadorZonaLibre" name="indicadorZonaLibre">
            </p-checkbox>
          </div>

          <div class="col-12 md:col-6 lg:col-6" *ngIf="f.indicadorZonaLibre.value === true">
            <div class="div-form">
              <label>* {{ 'ZONES.LBL_HOMOLOGACIONSHIVAM' | translate }}</label>
              <input type="text" pInputText name="homologacion" id="idHomologacion" appTexto [sinLetras]="true"
                [sinCaracteres]="true" [sinComa]="true" [sinPunto]="true" [sinEspacio]="true" maxlength="10"
                formControlName="homologacionUsuario" capitalize required="true" placeholder="{{ 'ZONES.LBL_HOMOLOGACIONSHIVAM' |
                          translate}}" />
              <div class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.homologacionUsuario.invalid">
                {{'ZONES.LBL_HOMOLOGACIONSHIVAM' | translate}} {{'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
        </div>

        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!guardando">
              <a (click)="goBack((f.dirty === true))" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
              <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}" type="submit" pButton></button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>
    </p-accordionTab>
    <p-accordionTab header="{{ 'ZONES.LBL_BARRIOS' | translate }}" [selected]="tabSeleccionado === 'BARRIO'"
      [disabled]="!zone || !zone.idZona">
      <form (ngSubmit)="f2.valid && onSubmitBarrios()" #f2="ngForm" novalidate class="form-horizontal"
        *ngIf="zone.idZona">
        <div class="grid form-group">
          <div class="col-12 md:col-6 lg:col-6" *ngIf="paises.length>0 && zone.idClasificacionZona!==null">
            <div class="div-form">
              <label>{{ 'ZONES.LBL_PAIS' | translate }}</label>
              <p-dropdown disableTab  id="pais" name="pais" #pais="ngModel" [options]="paises"  [filter]="true"
                (onChange)="changePais($event.value)" [(ngModel)]="idPais"
                placeholder="{{'LBL_SELECCIONE' | translate}}"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"></p-dropdown>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-6" *ngIf="departamentos.length>0">
            <div class="div-form">
              <label>{{ 'ZONES.LBL_DEPARTAMENTO' | translate }}</label>
              <p-dropdown disableTab  id="departamento" class="form-control" name="departamento" #departamento="ngModel"
                [options]="departamentos"  [filter]="true"
                (onChange)="changeDepartamento($event.value)" [(ngModel)]="idDepartamento"
                placeholder="{{'LBL_SELECCIONE' | translate}}"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"></p-dropdown>
            </div>
          </div>
        </div>
        <div class="grid form-group">
          <div class="col-12 md:col-6 lg:col-6" *ngIf="municipios.length>0">
            <div class="div-form">
              <label>{{ 'ZONES.LBL_MUNICIPIO' | translate }}</label>
              <p-dropdown disableTab  id="municipio" name="municipio" #municipio="ngModel" [options]="municipios"
                 [filter]="true" (onChange)="changeMunicipio($event.value)" [(ngModel)]="idMunicipio"
                placeholder="{{'LBL_SELECCIONE' | translate}}"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"></p-dropdown>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 md:col-6 lg:col-6 text-center" *ngIf="cargando">
            <i class="fa fa-spinner fa-pulse fa-fw"></i> Cargando
          </div>
          <div class="col-12 md:col-12 lg:col-12" *ngIf="!cargando">
            <div class="div-form">
              <label>{{ 'ZONES.LBL_BARRIOS' | translate }}</label>
              <p-pickList [source]="barriosDisponibles" [target]="barriosSeleccionados" [showTargetControls]="false"
                [showSourceControls]="false"  id="barrio" filterBy="descripcionDivisonPolitica">
                <ng-template let-barrio pTemplate="item">
                  {{ barrio.camino }}
                </ng-template>
              </p-pickList>
            </div>
          </div>
        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!guaBarrios">
              <a (click)="goBack((f2.dirty === true))" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
              <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}" type="submit" pButton></button>
            </div>
            <div *ngIf="guaBarrios">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>
    </p-accordionTab>
  </p-accordion>
</div>

<p-confirmDialog #cd key="zon-editar">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog #cdC key="zon-agregar">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_ACEPTAR' | translate }}" (click)="cdC.accept()"></button>
  </ng-template>
</p-confirmDialog>
